import { CaseEvent } from './panel.models';

/**
 * Dokąd prowadzi zdarzenie: `route` z API (uwaga 9 z testu 02.11), a bez niego (starsze API) — zmiana opiekuna (D48),
 * przegląd auta (Issue 35), zgłoszenie (Issue 40) albo etap sprawy.
 */
export function eventLink(e: CaseEvent): (string | number)[] {
    if (e.route) {
        return [e.route.split('?')[0]];
    }

    if (e.type === 'advisor_changed') {
        return ['/konto'];
    }

    if (e.vehicleId) {
        return ['/pojazdy', e.vehicleId];
    }

    return e.ticketId ? ['/zgloszenia', e.ticketId] : ['/sprawy', e.caseId ?? ''];
}

export function eventQuery(e: CaseEvent): Record<string, string> | null {
    if (e.route) {
        const query = e.route.split('?')[1];

        if (!query) {
            return null;
        }

        const params: Record<string, string> = {};
        new URLSearchParams(query).forEach((value, key) => (params[key] = value));

        return params;
    }

    return !e.ticketId && !e.vehicleId && e.stageCode ? { etap: e.stageCode } : null;
}
